import AspectRatio from '@mui/joy/AspectRatio';
import Button from '@mui/joy/Button';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import { Link } from 'react-router-dom';

type Props = {
  _id: string;
  bannerImage: string;
  title: string;
  description: string;
  members: Array<string>;
  resources: Array<string>;
  posts: Array<any>;
};

export const TopicCard = (props: Props) => {
  const { _id, bannerImage, title, description, members } = props;

  return (
    <Link to={`${_id}`}>
      <Card>
        <div>
          <Typography level="title-lg">{title}</Typography>
          <Typography level="body-sm">{description}</Typography>
        </div>
        <AspectRatio ratio="4/3">
          <img
            src={bannerImage}
            // srcSet="https://images.unsplash.com/photo-1527549993586-dff825b37782?auto=format&fit=crop&w=286&dpr=2 2x"
            loading="lazy"
            alt=""
          />
        </AspectRatio>
        <CardContent orientation="horizontal">
          <div>
            <Typography level="body-xs">Deelnemers</Typography>
            <Typography sx={{ fontSize: 'lg', fontWeight: 'lg' }}>
              {members.length}
            </Typography>
          </div>
          <Button
            variant="solid"
            size="md"
            color="primary"
            aria-label="Explore Bahamas Islands"
            sx={{ ml: 'auto', alignSelf: 'center', fontWeight: 600 }}
          >
            Bekijken
          </Button>
        </CardContent>
      </Card>
    </Link>
  );
};
